<script setup lang="ts">
import type { Block, Section } from '@/models'
import { type PropType, ref } from 'vue'
import SiteHeaderBlock from '../blockStyles/SiteHeaderBlock.vue'
import FlexibleBlock from '../blockStyles/FlexibleBlock.vue'
import QuotationBlock from '../blockStyles/QuotationBlock.vue'

const props = defineProps({
  section: {
    type: Object as PropType<Section>,
    required: true,
  },
  isHeaderBlock: {
    // True if this is the first Block on the page
    type: Boolean,
    default: false,
  },
})

const block = ref(props.section as Block)
const blockViews = {
  'site-header': SiteHeaderBlock,
  flexible: FlexibleBlock,
  quotation: QuotationBlock,
}
const blockStyle = blockViews[block.value.style]
</script>

<template>
  <component v-if="blockStyle" :blockData="block" :isHeaderBlock="isHeaderBlock" :is="blockStyle" />
</template>
